module.exports = __webpack_public_path__ + "static/img/mobile-model.e33e7be3.png";